module.exports = __webpack_public_path__ + "static/media/download-zip.4f927f87.svg";